import React from "react";
import { useTranslation } from "react-i18next";
import ReferenceListPage from "../components/ReferenceListPage";
import { branchesAPI } from "../services/api";
import { loadBranches } from "../store/slices/referenceDataSlice";
import { PERMISSIONS } from "../utils/permissions";

const BranchesPage = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <ReferenceListPage
      title={t("sidebar.branches")}
      api={branchesAPI}
      reloadThunk={loadBranches}
      requiredPermission={PERMISSIONS.MANAGE_BRANCHES}
      onNavigate={onNavigate}
      columns={[
        { field: "branch_id", label: "#" },
        { field: "name_en", label: t("referencePages.nameEn") },
        { field: "name_ar", label: t("referencePages.nameAr") },
        { field: "mobile", label: t("referencePages.mobile") },
      ]}
      formFields={[
        {
          name: "name_en",
          label: t("referencePages.nameEn"),
          required: true,
        },
        {
          name: "name_ar",
          label: t("referencePages.nameAr"),
          required: true,
        },
        {
          name: "mobile",
          label: t("referencePages.mobile"),
          required: true,
        },
        {
          name: "google_maps_location",
          label: t("referencePages.googleMaps"),
          type: "url",
        },
      ]}
    />
  );
};

export default BranchesPage;
